import './ValuesBar.scss'
import {useEffect, useState} from "react";
import {map} from "lodash";

/**
 * value example:
 * {
 *     value: 20,
 *     label: 'label'
 *     color: 'red'
 *     tooltip: 'tooltip'
 *     onClick: () => {}
 *     onHover: () => {}
 *     onLeave: () => {}
 *     className: 'className'
 * }
 * */

/**
 * Component to render a horizontal bar with multiple value segments
 * 
 * @param {object} params - Component parameters
 * @param {Array} params.values - Array of value data objects
 * @param {boolean} params.showPercent - Whether to show percentages instead of absolute values
 * @param {boolean} params.small - Whether to use smaller styling for the bar
 * @returns {JSX.Element} Rendered component
 */
export const ValuesBar = ({ values, showPercent, small }) => {
    const [valuesParams, setValuesParams] = useState([]);

    const calculateParams = () => {
        const totalValue = values.reduce((acc, value) => acc + value.value, 0);

        // Calculate the percentage width for each segment based on its proportion of the total
        const newValuesParams = map(values, (value) => {
            // Calculate each segment as % of the total value (always proportional)
            const widthPercent = totalValue > 0 ? (value.value / totalValue) * 100 : 0;

            return {
                value: value.value,
                widthPercent,
                colorClass: value.colorClass
            };
        });

        setValuesParams(newValuesParams);
    };

    useEffect(() => {
        calculateParams();
    }, [values, showPercent]);

    return <div className={`ValuesBar ${small ? 'small' : ''}`}>
        {valuesParams && map(valuesParams, (value) => {
            const percentValue = `${value.widthPercent.toFixed(1)}%`;
            return <div className={`barValue ${value.colorClass}`} style={{ width: `${value.widthPercent}%` }} title={showPercent ? percentValue : value.value}>
                {showPercent && value.widthPercent > 10 ? <div className="barValueText">{percentValue}</div> : ''}
                {!showPercent && value.widthPercent > 5 ? <div className="barValueText">{value.value}</div> : ''}
            </div>;
        })}
    </div>;
};